export const getResourcesVars = {}
